module.exports = __webpack_public_path__ + "img/106063.bda6f0d3.png";